export default {
  'en': 'en',
  'it': 'it'
}